import { render } from "./AddEmployeeDialog.vue?vue&type=template&id=0255f858"
import script from "./AddEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./AddEmployeeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__